<template>
    <card style="background-color:#e9ecef;">
      <h5>{{ $t("title") }}</h5>

     <div v-if="!sent">

      {{ $t("info") }}
      <br/>
      <br/>

      <small class="text-uppercase font-weight-bold">{{
        $t("openfeedback")
      }}</small>
      <br/>

      <base-input
        maxLength="5000"
        id="input-openfeedback"
        class="mb-3"
        v-model="form.openfeedback"
        v-bind:placeholder="$t('openfeedback')"
      />

      <small class="text-uppercase font-weight-bold">{{
        $t("facilitation")
      }}</small>
      <br/>

      <base-button
        v-for="i in 10"
        :key="i"
        size="md"
        type="info"
        :class="form.facilitation === i ? 'active' : ''"
        style="margin: 5px"
        v-on:click="form.facilitation=i"
        >{{ i }}
      </base-button>

      <br/>
      <br/>

      </div>

      <base-button style="white-space: normal;"
        type="success"
        v-on:click="onSubmit()"
        :disabled="disableSubmit"
        >{{ sent ? $t("thankyou") : $t("submit") }}</base-button
      >
    </card>
</template>

<script>
import {
  sendFacilitatorFeedback,
} from "../services/APIService";

export default {
  data: function () {
    return {
      form: {
        openfeedback: null,
        facilitation: 0,
      },
      sent: false,
    };
  },
  computed: {
    disableSubmit() {
      if (this.sent) {
        return true;
      }

      if (!this.form.openfeedback && this.form.facilitation === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    onSubmit() {
      sendFacilitatorFeedback(this.form.openfeedback, this.form.facilitation, this.$store.state.main.game.id, this.$store.state.main.game.gameCode, this.$i18n.locale)
      this.sent = true;
    },
  },
};
</script>

<i18n>
{
  "en": {
    "title": "Facilitator Feedback form (only shown to facilitators)",
    "info": "Your feedback is very valuable for improving the simulation experience further! Your contact information is attached to the feedback, and the feedback is provided only to the tool developers (SmoothTeam).",
    "facilitation": "How did you succeed in the facilitation this time?",
    "openfeedback": "Open feedback (e.g. feedback on the simulation or any other feedback for SmoothTeam)",
    "submit": "Submit",
    "thankyou": "Thank you!"
  },
  "fi": {
    "title": "Pelinjohtajan palautelomake (näkyy vain pelinjohtajalle)",
    "info": "Palautteesi on erittäin arvokasta simulaatiokokemuksen parantamista varten! Yhteystietosi liitetään palautteeseen, joka välitetään SmoothTeam-palvelun kehittäjille.",
    "facilitation": "Miten fasilitointi mielestäsi onnistui?",
    "openfeedback": "Avoin palaute (esimerkiksi palaute simulaatiosta tai muut terveiset SmoothTeamille)",
    "submit": "Lähetä",
    "thankyou": "Kiitos!"
  },
  "sv": {
    "title": "Feedbackformulär (endast synlig för spelledare)",
    "info": "Din feedback är mycket värdefull för att förbättra simuleringsupplevelsen ytterligare! Dina kontaktuppgifter är bifogade till feedbacken, och feedbacken lämnas endast till verktygsutvecklarna (SmoothTeam).",
    "facilitation": "Hur lyckades du med att underlätta den här gången?",
    "openfeedback": "Öppen feedback (t.ex. feedback om simuleringen eller annan feedback till SmoothTeam)",
    "submit": "Slutför",
    "thankyou": "Tack för hjälpen"
  },
  "de": {
    "title": "Feedback-Formular (werden nur den Spielmanager angezeigt)",
    "info": "Ihr Feedback ist sehr wertvoll, um das Simulationserlebnis weiter zu verbessern! Ihre Kontaktinformationen sind dem Feedback beigefügt, und das Feedback wird nur an die Entwickler des Tools (SmoothTeam) weitergeleitet.",
    "facilitation": "Wie ist Ihnen die Moderation dieses Mal gelungen?",
    "openfeedback": "Offenes Feedback (z.B. Feedback zur Simulation oder sonstiges Feedback für SmoothTeam)",
    "submit": "Einreichen",
    "thankyou": "Vielen Dank!" 
  },
  "ko": {
      "title": "피드백 설문 (퍼실리테이터용)",
      "info": "퍼실리테이터분들의 피드백은 시뮬레이션 개선에 큰 도움이 됩니다. 남겨주시는 의견은 연락처 정보와 함께 스무스팀 개발팀에게 전달됩니다.",
      "facilitation": "본 과정의 퍼실리테이션은 원활히 진행되었나요?",
      "openfeedback": "자유롭게 피드백 의견을 남겨주세요. (예: 본 진행 모듈 관련 혹은 홈페이지 기능 등)",
      "submit": "제출",
      "thankyou": "감사합니다."
  }  
}
</i18n>
